import { library } from '@fortawesome/fontawesome-svg-core'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Paragraph from 'Root/App/Paragraph'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'
import { secondsToDuration } from 'lib/seconds-to-duration'
import filter from 'lodash/filter'
import join from 'lodash/join'

import styles from './index.module.css'

// ----------------------------------------------------------------------------

library.add(faLink)

// ----------------------------------------------------------------------------

const Link = ({ content, canManage }) => (
  <div>
    <div className={styles.wrapper}>
      <div
        className={
          !canManage && content.hasUserVisited
            ? styles.iconContainerVisited
            : styles.iconContainer
        }
      >
        <FontAwesomeIcon className={styles.icon} icon={['fas', 'link']} />
      </div>

      <div>
        <Title size="2XS" maxRows={2}>
          {content.title}
        </Title>
        <Paragraph maxRows={2}>{content.description}</Paragraph>
        <PreTitle className={styles.preTitle}>
          {join(
            filter([
              content.label || content.domain,
              secondsToDuration(content?.duration),
            ]),
            ' · '
          )}
        </PreTitle>
      </div>
    </div>
  </div>
)

export default Link
